var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.5 0C20.7397 0 21.7995 0.439953 22.6798 1.32021C23.56 2.20046 24 3.26027 24 4.49998V19.5C24 20.7397 23.56 21.7995 22.6798 22.6798C21.7995 23.56 20.7397 24 19.5 24H16.5625V14.7032H19.6719L20.1405 11.0779H16.5625V8.76546C16.5625 8.18235 16.685 7.74485 16.9296 7.45295C17.1743 7.1614 17.651 7.01544 18.3594 7.01544L20.2658 7.00004V3.76567C19.6092 3.67187 18.6824 3.62497 17.4844 3.62497C16.0676 3.62497 14.9349 4.04148 14.0858 4.87483C13.2367 5.70819 12.8125 6.88524 12.8125 8.40635V11.0779H9.68736V14.7032H12.8125V24H4.49998C3.26062 24 2.20046 23.56 1.32021 22.6798C0.439953 21.7995 0 20.7397 0 19.5V4.49998C0 3.26027 0.439953 2.20046 1.32021 1.32021C2.20046 0.439953 3.26062 0 4.49998 0H19.5Z"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Facebook;

Facebook.default = Facebook;
